
//UAT
// const api = {
//     BASE_URL: "https://ubr8htfrxj.execute-api.ap-south-1.amazonaws.com/default/ainxt_signature-validation_service",
//     x_api_key: "KFMHLbn1ph7rJUmoQaUCu3MybLXVvGP28els57p9",
//     authorizationToken: "vH24IILXH3wR4kRY"
// }

// prod
const api = {
    BASE_URL: "https://iohj951bp4.execute-api.ap-south-1.amazonaws.com/default/philipscapital-signature-validate",
    x_api_key: "cj7kqLokOMa6RB1FXCHW28huwInDjdEI8e3RQt7u",
    authorizationToken: "uR1k84DxQcHTcqzE"
}

export default api;